import { z } from 'zod'

export const ContractorFormEntitySchema = z.object({
  name: z.string(),
  email: z.string(),
})

export type ContractorFormEntity = z.infer<typeof ContractorFormEntitySchema>
